module.exports = __webpack_public_path__ + "static/media/image_slider_home_01.827a82c1.jpg";